import { Route, Routes } from 'react-router-dom';
import SystemAdmin from './SystemAdmin';
import StudentAssessmentPage from './StudentAssessmentPage';

/** Screen-MPL-11 — `/master-admin` console with nested student assessment route. */
export default function MasterAdminConsole() {
  return (
    <Routes>
      <Route index element={<SystemAdmin />} />
      <Route path="students/:studentKey/assessment" element={<StudentAssessmentPage />} />
    </Routes>
  );
}
